import { useParams } from "react-router-dom";
import CustomForm from '../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../config/config';
import Fetch from '../../../core/util/core/Fetch';
import { useEffect, useState } from 'react';
import { chooseProfileFilter } from "../../helpers/chooseProfileFilter";
import sleep from "sleep-promise";

function Form() {
    const profileFilter = chooseProfileFilter()

    const hiddenValues = {}

    if (profileFilter.gci_company_id) {
        hiddenValues.gci_company_id = profileFilter.gci_company_id
    }

    const getOrganizationType = async (values) => {
        if (profileFilter.organization_type) {
            return profileFilter.organization_type;
        }
        const companyId = values?.gci_company_id;
        if (!companyId) return 'default';
        const company = await Fetch.post(`${config.endpoints.backend}gci/companies/getById`, { id: companyId });
        return company?.organization_type || 'default';
    };


    const { id } = useParams();
    const [form, setForm] = useState();
    const [formContent, setFormContent] = useState(<>Carregando...</>);

    const endpointBackend = config.endpoints.backend;

    const paths = {
        endpointSave: `${endpointBackend}gci/projects/save`,
        endpointGetAllProjectTypes: `${endpointBackend}gci/project-types/getall`,
        endpointGetAllProjectTypesThirdSector: `${endpointBackend}gci/project-types-third-sector/getall`,
        endpointGetAllCompanies: `${endpointBackend}gci/companies/getall`,
        endpointGetAllCities: `${endpointBackend}gci/cities/getall`,
        endpointGetAllStates: `${endpointBackend}gci/states/getall`,
        endpointGetAllCommonAreas: `${endpointBackend}gci/common-areas/getall`,
        endpointGetAllClients: `${endpointBackend}gci/clients/getall`,
        endpointGetAllUsers: `${endpointBackend}gci/users/getall`,
        endpointGetById: `${endpointBackend}gci/projects/getById`,
        urlGoBack: `/gci/projects/list`,
        pathView: `/gci/projects/view`
    }

    const labels = {
        labelTitleAdd: "Novo Projeto",
        labelTitleEdit: "Editar Projeto",
        labelTitleView: 'Visualizar Projeto'
    }

    const getForm = (values, organizationType = 'default') => {
        const isDefaultOrganizationType = organizationType === 'default';

        const defaultFields = [
            {
                name: 'land_area',
                type: 'decimal',
                label: 'Área do Terreno m²',
                validations: {
                    required: false
                },
                columnSize: 6,
            },
            {
                name: 'built_area',
                type: 'decimal',
                label: 'Área Construída m²',
                validations: {
                    required: false
                },
                columnSize: 6,
            },
            {
                name: 'common_areas',
                type: 'multiinput',
                label: 'Áreas Comuns',
                sortBy: 'index',
                showDeleteButton: true,
                form: [
                    {
                        name: 'gci_common_area_id',
                        type: 'select',
                        label: 'Área Comum',
                        options: [],
                        optionsEndpoint: {
                            endpoint: paths.endpointGetAllCommonAreas,
                            label: 'name',
                            value: 'id'
                        },
                        validations: {
                            required: false
                        }
                    },
                ],
                validations: {
                    required: false
                },
                columnSize: 12,
            }
        ];

        const thirdSectorFields = [
            {
                name: 'clients',
                type: 'multiinput',
                label: 'Cliente (s)',
                sortBy: 'index',
                showDeleteButton: true,
                form: [
                    {
                        name: 'gci_client_id',
                        type: 'select',
                        label: 'Cliente',
                        options: [],
                        optionsEndpoint: {
                            endpoint: paths.endpointGetAllClients,
                            label: 'name',
                            value: 'id',
                            params: {
                                filter: {
                                    ...profileFilter,
                                    gci_company_id: profileFilter.gci_company_id || values.gci_company_id || null,
                                }
                            }
                        },
                        validations: {
                            required: true
                        }
                    }
                ],
                validations: {
                    required: true
                },
                columnSize: 12
            }
        ]

        let form = {
            hiddenValues,
            fields: [
                !profileFilter.gci_company_id ? {
                    name: 'gci_company_id',
                    type: 'select',
                    label: 'Empresa',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllCompanies,
                        label: 'name',
                        value: 'id'
                    },
                    validations: {
                        required: true
                    },
                    handleChange: async (element, field, values) => {
                        const organizationType = await getOrganizationType(values);
                        const form = getForm(values, organizationType);
                        form.values = values;
                        setForm(form);
                        setFormContent(<></>);
                        await sleep(1);
                        setFormContent(
                            <CustomFormContainer
                                form={form}
                                content={<CustomForm form={form} />}
                            />)
                    },
                    columnSize: 12
                } : {},
                {
                    name: isDefaultOrganizationType ? 'gci_project_type_id' : 'gci_project_type_third_sector_id',
                    type: 'select',
                    label: 'Tipo de Projeto',
                    options: [],
                    optionsEndpoint: {
                        endpoint: isDefaultOrganizationType ? paths.endpointGetAllProjectTypes : paths.endpointGetAllProjectTypesThirdSector,
                        label: 'project_type',
                        value: 'id',
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'project_name',
                    type: 'text',
                    label: 'Nome do Projeto',
                    validations: {
                        required: true
                    },
                    columnSize: 12,
                },
                ...(isDefaultOrganizationType ? defaultFields : thirdSectorFields),
                {
                    name: 'city_id',
                    type: 'select',
                    label: 'Município',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllCities,
                        label: 'city_name',
                        value: 'city_id',
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'address',
                    type: 'address',
                    validations: {
                        required: true
                    },
                    columnSize: 12,
                    autocomplete: true,
                    hasComplement: true
                },
                {
                    name: 'obs',
                    type: 'textarea',
                    label: 'Observações',
                    validations: {
                        required: false
                    },
                    columnSize: 12,
                },
                {
                    name: 'photo',
                    type: 'fileS3',
                    label: 'Foto Fachada',
                    extensionAccept: '.jpeg,.jpg,.png',
                    limitFileSize: 200,
                    validations: {
                        required: false
                    },
                    columnSize: 12
                }
            ],
            ...paths,
            ...labels,
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};
            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
            }

            const organizationType = await getOrganizationType(values);
            const form = getForm(values, organizationType);

            setForm(form);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />} />
            );
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
